<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">

            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input placeholder="用户id" v-model="params.user_id"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
                </el-col>
              <el-select v-model="params.source" placeholder="来源" clearable @change="searchData" style="width: 15%;">
                <el-option
                  v-for="item in source"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>

              </el-select>
<!--                <el-col :span="4">-->
<!--                    <el-input placeholder="兑吧订单号" v-model="params.orderNum"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>-->
<!--                </el-col>-->
<!--                <el-col :span="4">-->
<!--                    <el-select v-model="params.status" @change="numberSearch" placeholder="兑吧状态" style="width: 100%;">-->
<!--                        <el-option-->
<!--                                v-for="selectStatus in dubaStatus"-->
<!--                                :key="selectStatus.key"-->
<!--                                :label="selectStatus.name"-->
<!--                                :value="selectStatus.value">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-col>-->
                <el-col :md="10" :lg="8">
                    <el-date-picker v-model="created" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
                </el-col>
              <el-col :span="2">
                <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-button-group>
                    </el-button-group>
                </el-col>
            </el-row>
            <el-table :data="list"  :height="wheight-140" v-loading="loading">
                <el-table-column type="selection" align="center" label="全选" ></el-table-column>
                <el-table-column prop="user_id" label="用户id"></el-table-column>
                <el-table-column prop="source" label="来源"></el-table-column>

<!--                <el-table-column prop="expend" label="积分">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-tag v-if="scope.row.expend == 1" type="success" size="mini">+ {{scope.row.points}}</el-tag>-->
<!--                        <el-tag v-if="scope.row.expend == 0" type="danger" size="mini">- {{scope.row.points}}</el-tag>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="orderNum" label="兑吧订单号"></el-table-column>-->
<!--                <el-table-column prop="bizId" label="系统单号"></el-table-column>-->
<!--                <el-table-column prop="type" label="类型类型">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span v-if="scope.row.type === 'alipay'" class="amount-cur"> 支付宝 </span>-->
<!--                        <span v-if="scope.row.type === 'qb'" class="amount-cur"> Q币 </span>-->
<!--                        <span v-if="scope.row.type === 'coupon'" class="amount-cur"> 优惠券 </span>-->
<!--                        <span v-if="scope.row.type === 'object'" class="amount-cur"> 实物 </span>-->
<!--                        <span v-if="scope.row.type === 'phonebill'" class="amount-cur"> 话费 </span>-->
<!--                        <span v-if="scope.row.type === 'phoneflow'" class="amount-cur"> 流量 </span>-->
<!--                        <span v-if="scope.row.type === 'virtual'" class="amount-cur"> 虚拟商品 </span>-->
<!--                        <span v-if="scope.row.type === 'game'" class="amount-cur"> 游戏 </span>-->
<!--                        <span v-if="scope.row.type === 'hdtool'" class="amount-cur"> 活动抽奖 </span>-->
<!--                        <span v-if="scope.row.type === 'sign'" class="amount-cur"> 签到 </span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="actualPrice" label="扣费">-->
<!--                    <template slot-scope="scope">-->
<!--                    {{scope.row.actualPrice / 100}}-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="status" label="兑吧状态">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span v-if="scope.row.status == 0 " class="amount-cur"> 未通知 </span>-->
<!--                        <span v-if="scope.row.status == 1 " class="amount-cur"> 成功 </span>-->
<!--                        <span v-if="scope.row.status == 2 " class="amount-cur"> 失败 </span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="np_status" label="np状态">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span v-if="scope.row.np_status == 0 " class="amount-cur"> 未处理 </span>-->
<!--                        <span v-if="scope.row.np_status == 1 " class="amount-cur"> 成功 </span>-->
<!--                        <span v-if="scope.row.np_status == 2 " class="amount-cur"> 失败 </span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="return_status" label="退返积分状态">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span v-if="scope.row.return_status == 0 " class="amount-cur"> 未退回 </span>-->
<!--                        <span v-if="scope.row.return_status == 1 " class="amount-cur"> 已退回 </span>-->
<!--                    </template>-->
<!--                </el-table-column>-->


              <el-table-column prop="name"  label="用户名称">
                <template slot-scope="scope">
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="mobile"  label="手机号">
                <template slot-scope="scope">
                  <span>{{scope.row.mobile }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="created_at"  label="创建时间">
                <template slot-scope="scope">
                  <span>{{scope.row.created_at }}</span>
                </template>
              </el-table-column>
                <el-table-column prop="updated_at"  label="更新时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.updated_at }}</span>
                    </template>
                </el-table-column>


<!--                <el-table-column label="操作" min-width="100">-->
<!--                    <template slot-scope="scope">-->

<!--                        <el-button type="text" @click="getRealTimePointxq(scope.row.params)" style="margin-left: 0">附加参数</el-button>-->
<!--                        <el-button type="text" @click="getRealTimePoint(scope.row.user_id,scope.row.card_id)" style="margin-left: 0">实时积分</el-button>-->
<!--                        <el-button type="text" @click="getOneYearsPoint(scope.row.user_id,scope.row.card_id)" style="margin-left: 0">1年积分明细</el-button>-->
<!--                        <el-button type="text" @click="returnPoint(scope.row.user_id,scope.row.card_id,scope.row.id,scope.row.return_status,scope.row.np_status,scope.row.status)" style="margin-left: 0">退返积分</el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->

            </el-table>
            <div v-if="total_count > params.pageSize" class="content-padded content-center">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.page"
                        :total="total_count" :page-size="params.pageSize">
                </el-pagination>
            </div>
<!--            <el-dialog title="详情" :visible.sync="realTimeDialogxq" :before-close="handleGetRealTimePointxq" width="57%">-->
<!--                <template>-->
<!--                    <el-row :gutter="100">-->
<!--                        <el-col :span="24">-->
<!--                            附加参数:{{realTimeData}}-->
<!--                        </el-col>-->
<!--                    </el-row>-->

<!--                </template>-->
<!--                <div slot="footer" class="dialog-footer">-->
<!--                    <el-button @click.native="handleGetRealTimePointxq">确定</el-button>-->
<!--                </div>-->
<!--            </el-dialog>-->
<!--            <el-dialog title="实时积分" :visible.sync="realTimeDialog" :before-close="handleGetRealTimePoint" width="57%">-->
<!--                <template>-->
<!--                    <el-row :gutter="100">-->
<!--                        <el-col :span="24">-->
<!--                            实时积分:{{realTimeData}}-->
<!--                        </el-col>-->
<!--                    </el-row>-->

<!--                </template>-->
<!--                <div slot="footer" class="dialog-footer">-->
<!--                    <el-button @click.native="handleGetRealTimePoint">确定</el-button>-->
<!--                </div>-->
<!--            </el-dialog>-->
<!--            <el-dialog title="1年积分明细" :visible.sync="realTimeDialog1years" :before-close="handleGetRealTimePoint1years" width="57%">-->
<!--                <template>-->
<!--                    <el-row :gutter="100">-->
<!--                        <el-col :span="24">-->
<!--                            剩余：{{realTimeData1years.integral}}-->
<!--                        </el-col>-->
<!--                    </el-row>-->
<!--                    <el-table-->
<!--                            :data="realTimeData1years.jfmx">-->
<!--                        <el-table-column-->
<!--                                prop="credate"-->
<!--                                label="时间">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column-->
<!--                                prop="thisintegral"-->
<!--                                label="积分">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column-->
<!--                                prop="docid"-->
<!--                                label="docid">-->
<!--                        </el-table-column>-->
<!--                    </el-table>-->

<!--                </template>-->
<!--                <div slot="footer" class="dialog-footer">-->
<!--                    <el-button @click.native="handleGetRealTimePoint1years">确定</el-button>-->
<!--                </div>-->
<!--            </el-dialog>-->

        </div>
        <router-view></router-view>
    </div>
</template>
<script>

  import { mapGetters } from 'vuex'
  import { getThirdList,ThirdJumpExport} from '../../../api/trade.js'


    export default {
        data () {
            return {
              source: [
                {label: '众安', value: 100001},
                {label: '水滴', value: 100002}

              ],
                editTitleCategroy: '',
                editCategroyVisible:false,
                CategoryList:[],
                office_area_name:[],
                office_area_id:'',
                loadingCategoryF: false,
                submitLoading:false,
                dialogVisible: false,
                time_start_begin: '',
                time_start_end: '',
                created:'',
                changeStatus: true,
                activeName: 'first',
                total_count: 0,
                detailDialog: false,
                pcDialogVisible: false,
                dialogTitle: '',
                select_tags_value: '',
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    user_id: '',
                    time_start_begin : '',
                    time_start_end :'',
                    orderNum:'',
                    status:''
                },
                // 兑吧状态
                dubaStatus:[
                    {key:0,name:'全部',value:'-1'},
                    {key:1,name:'未通知/未处理',value:'0'},
                    {key:2,name:'成功',value:'1'},
                    {key:3,name:'失败',value:'2'}
                ],
                // 退回积分参数
                return_params:{
                    user_id:'',
                    cardno:'',
                    duiba_id:''
                },
                // 详情
                realTimeDialogxq:false,
                realTimeDialog:false,
                realTimeDialog1years:false,
                realTimeData:'查询中...',
                realTimeDataxq:'查询中...',
                realTimeData1years:[],
                realTimePointparams:{
                    user_id:'',
                    cardno:''
                },
                form: {
                    distributor_id: null,
                    mobile: '',
                    address: '',
                    name: '',
                    is_valid: 'true',
                    regions_id: [],
                    regions: [],
                    shop_id: 0,
                    contact: ''
                },
                list: [],
                rowdata: {},
                downDistributorVal: false,
                distributor_id: [],
                tag: {
                    dialog: false,
                    editItem: [],
                    list: [],
                    form: {
                        tag_ids: [],
                        distributor_id: []
                    },
                    currentTags: [],
                    tags: []
                },
                chooseCat:[],
                checkAll:false  //全选的v-model值
            }
        },
        components: {  },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            closeDialog () {
                this.dialogVisible = false
                this.pcDialogVisible = false
            },
            isValidSelectHandle () {
                this.params.page = 1
                this.getList()
            },

            numberSearch (e) {
                this.params.page = 1
                this.getList()
            },
            dateChange (val) {
                console.log(val)

                if (val.length > 0) {
                    this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                    this.params.time_start_begin = this.time_start_begin
                    this.params.time_start_end = this.time_start_end
                } else {
                    this.time_start_begin = ''
                    this.time_start_end = ''
                    this.params.time_start_begin = ''
                    this.params.time_start_end = ''
                }
                this.params.page = 1

                this.getList()
            },
          searchData () {
            this.params.page = 1
            this.getList()
          },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            dialogOpen (detail = null) {
                this.$router.push({path: this.matchHidePage('editor')})
            },
          exportData() {

            this.exportloading = true
            this.params.export = 1
            ThirdJumpExport(this.params).then(res => {
              this.exportloading = false
              console.log(res)
              if (res.status) {
                this.$message({
                  type: 'success',
                  message: '已加入执行队列，请在设置-导出列表中下载'
                })
                return
              } else if (res.data.url) {
                this.downloadUrl = res.data.url
                this.downloadName = res.data.filename
                this.downloadView = true
              } else {
                this.$message({
                  type: 'error',
                  message: '无内容可导出 或 执行失败，请检查重试'
                })
                return
              }
            }).catch(error => {
              this.exportloading = false
            })
          },


            getList () {
                this.loading = true
                console.log(this.params)

                getThirdList(this.params).then(response => {
                    if (response.data.data.list) {
                        this.list = response.data.data.list
                        this.total_count = response.data.data.total_count
                    }
                    this.loading = false
                })
            },
            // 查看详情
            getRealTimePointxq(params){
                this.realTimeDataxq = params ? params : '暂无'
                this.realTimeDialogxq = true
            },
            handleGetRealTimePointxq(){
                this.realTimeDialogxq = false
                this.realTimePointparams.user_id = ''
                this.realTimePointparams.cardno = ''
                this.realTimeDataxq = '查询中...'
            },

            // 实时积分
            getRealTimePoint(user_id,cardno){
                this.realTimePointparams.user_id = user_id
                this.realTimePointparams.cardno = cardno
                getUserCardRealTimePoint(this.realTimePointparams).then(
                    response => {
                        if(response.data.data){
                            this.realTimeData = response.data.data.points
                        }
                    }
                )
                this.realTimeDialog = true
            },
            handleGetRealTimePoint(){
                this.realTimeDialog = false
                this.realTimePointparams.user_id = ''
                this.realTimePointparams.cardno = ''
                this.realTimeData = '查询中...'
            },
            // 1年积分明细
            getOneYearsPoint(user_id,cardno){
                this.realTimePointparams.user_id = user_id
                this.realTimePointparams.cardno = cardno
                getlistbyNp(this.realTimePointparams).then(
                    response => {
                        if(response.data.data){
                            this.realTimeData1years = response.data.data
                        }
                    }
                )
                this.realTimeDialog1years = true
            },
            handleGetRealTimePoint1years(){
                this.realTimeDialog1years = false
                this.realTimePointparams.user_id = ''
                this.realTimePointparams.cardno = ''
                this.realTimeData1years = [];
            },
            // 退返积分
            returnPoint(user_id,cardno,duiba_point_log_id,return_status,np_status,status){
                this.$confirm('是否退返积分', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if(return_status == 1){
                        this.$alert('已经返回，不可重复退返');
                        return false;
                    }
                    if(np_status == 0 || np_status == 2){
                        this.$alert('积分未扣除，不可退返');
                        return false;
                    }
                    if(status == 1){
                        this.$alert('兑吧系统已处理，不可退返');
                        return false;
                    }
                    this.return_params.user_id = user_id;
                    this.return_params.cardno = cardno;
                    this.return_params.duiba_id = duiba_point_log_id;
                    returnPoint(this.return_params).then(
                        response => {
                            if(response.data.data){
                                this.$alert(response.data.data.msg);
                                this.getList();
                            }else{
                                this.$alert('出现异常');
                            }
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });

            },

            // 更新默认卡
            changeUserDefaultCard(user_id,cardno,mobile){
                this.$confirm('是否更新为默认卡', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {user_id:user_id,cardno:cardno,mobile:mobile}
                    changeUserDefaultCard(params).then(response => {
                        let changestatus = response.data.data.status

                        if (changestatus) {
                            this.$message.success('更新成功!')
                            return false
                        }else{
                            this.$message.error('更新失败')
                            return false
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },
            handleCancel () {
                this.editCategroyVisible=false
            },
            handleCancelLabelsDialog() {
                this.tag.dialog = false
            },
        },
        mounted () {
            this.getList()
        }
    }
</script>

<style lang="scss" scoped>
    .tag-users {
        padding-bottom: 10px;
        line-height: 1.2;
        .icon-user-circle1 {
            margin-right: 10px;
            font-size: 24px;
            color: #ccc;
        }
    }
    .selected-tags {
        padding-top: 15px;
        margin-bottom: 15px;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        .label {
            margin-bottom: 15px;
        }
        .el-tag {
            margin-right: 10px;
            margin-bottom: 15px;
        }
    }
    .tag-item {
        cursor: pointer;
        color: #666;
        border-color: #dadadd;
        margin-right: 10px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// thirdjump.vue?226ba5af